import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
    MobilityMapItemPopupContentComponent,
} from './components/mobility-map-item-popup-content/mobility-map-item-popup-content.component';
import { MobilityMapItem } from './definitions/mobility-map-item';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { AsyncPipe } from '@angular/common';
import { FilterMapperComponent } from '@ui/shared/ui-filter';
import { MobilityMapItemDetailsComponent } from './components/mobility-map-item-details/mobility-map-item-details.component';
import { BaseAppComponent } from '@ui/shared/feature-config';

@Component({
    selector: 'ui-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MapWithSidebarModule,
        AsyncPipe,
        FilterMapperComponent,
        MobilityMapItemDetailsComponent,
    ],
})
export class AppComponent extends BaseAppComponent<MobilityMapItem> {
    constructor() {
        super(MobilityMapItemPopupContentComponent);
    }
}
